import { IAppStore } from '../IAppStore';

const appStorePartialize = (state: IAppStore): any => {
  const {
    location,
    activeView,
    activeFlyin,
    activeFlyinView,
    flyinWidth,
    toolDialogWidth,
    toolbar,
    viewCollapse,
    mouseLocation,
    previewLayer,
    newAddedTopicLayer,
    notifications,
    layoutTitle,
    layoutSubTitle,
    printLegend,
    printScale,
    layoutId,
    orientation,
    formatValue,
    angle,
    printMapOnly,
    printedItems,
    showPrintedItems,
    mapExtent,
    activeDrawTool,
    isDrawActive,
    displayDrawInfoBox,
    selectedFeatureId,
    displayResetNotification,
    isLoggedIn,
    defaultResultProperties,
    showidentifyOverlay,
    showLegend,
    identifyLegend,
    identifyCoordinate,
    landownerEigentuemer,
    landownerNavigation,
    attributeSearch,
    currentAttributeSearchTopicId,
    loadingLayers,
    enabledIdentify,
    displayStartUpMessage,
    ...rest
  } = state;
  return rest;
};

export default appStorePartialize;
